'use strict';

var dialog = require('../../dialog');
var GoogleTagManagerClient = require('../../../../../bc_sheplersbootbarn_core/cartridge/js/util/GoogleTagManagerClient');
var OrderConfirmation = require('../orderconfirmation');

exports.initialize = initialize;

var applePaySession;
var options = {};
var buffer = {};

function initialize(optionsParameter) {
	options = optionsParameter || {};

	$('[payment-method-container="DW_APPLE_PAY"]').attr('can-make-payments', 'ApplePaySession' in window && 'canMakePayments' in ApplePaySession && ApplePaySession.canMakePayments());
	$('[payment-method-group-container="DW_APPLE_PAY"]').attr('can-make-payments', 'ApplePaySession' in window && 'canMakePayments' in ApplePaySession && ApplePaySession.canMakePayments());
	if (options.isCartPage || options.isCheckoutPage) {
		getApplePayPaymentRequest();
	}
	$(document).off('ApplePay.GetPaymentRequest').on('ApplePay.GetPaymentRequest Cart.UpdateSuccess ProductDetailPage.Variant.Updated ProductDetailPage.AddToCartOptionsSelect', function(event, data) {
		$('[payment-method-container="DW_APPLE_PAY"]').attr('can-make-payments', 'ApplePaySession' in window && 'canMakePayments' in ApplePaySession && ApplePaySession.canMakePayments());
		$('[payment-method-group-container="DW_APPLE_PAY"]').attr('can-make-payments', 'ApplePaySession' in window && 'canMakePayments' in ApplePaySession && ApplePaySession.canMakePayments());
		getApplePayPaymentRequest(getPdpPaymentRequestData(data));
	});

	$(document).off('click.ApplePay').on('click.ApplePay', '.submit-applepay-button', function(event) {
		var isVariantSelected = true;
		if (options.ProductId) {
			var sizeSelected = $('div.product-variations .size.size-options li.selected');
			var lengthSelected = $('div.product-variations .length.length-options li.selected').length;
			var widthSelected = $('div.product-variations .width.width-options li.selected').length;
			var isSizeSelected = sizeSelected.length || (lengthSelected && widthSelected);

			if (!isSizeSelected) {
				dialog.open({
					html: 'Please select a size',
					options: {
						dialogClass: 'dialog-alert',
						draggable: false
					}
				});
				isVariantSelected = false;
			}

			if (!$('div.product-variations .color.color-options li.selected').length) {
				dialog.open({
					html: 'Please select a color',
					options: {
						dialogClass: 'dialog-alert',
						draggable: false
					}
				});
				isVariantSelected = false;
			}
		}

		if (options.isCartPage || options.isCheckoutPage || isVariantSelected) {
			if (pageContext && pageContext.options && pageContext.options.GoogleTagManager && pageContext.options.GoogleTagManager.EnableGoogleAnalytics4) {
				var applePayEventData;
				var applePayEventOptions;
				if (pageContext.type == 'product') {
					if (pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4 && pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4.items && pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4.items.length > 0) {
						applePayEventData = {
							action_name: 'applepay',
							action_page_type: 'PDP',
							action_value: pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4.items[0].price,
							action_items: [pageContext.options.GoogleTagManager.DataLayerCacheForGoogleAnalytics4.items[0].item_id]
						}
					}
				} else if (pageContext.type == 'cart') {
					applePayEventData = {
						action_name: 'applepay',
						action_page_type: 'Cart'
					}
					applePayEventOptions = {
						DecorateDataLayerWithCartTotal: true,
						DecorateDataLayerWithCartTotalKey: 'action_value',
						DecorateDataLayerWithProductData: true,
						DecorateDataLayerWithProductDataKey: 'action_items'
					}
				} else if (pageContext.type == 'onepcheckout_groups') {
					applePayEventData = {
						action_name: 'applepay',
						action_page_type: 'Checkout'
					}
					applePayEventOptions = {
						DecorateDataLayerWithCartTotal: true,
						DecorateDataLayerWithCartTotalKey: 'action_value',
						DecorateDataLayerWithProductData: true,
						DecorateDataLayerWithProductDataKey: 'action_items'
					}
				}
				if (applePayEventData) {
					GoogleTagManagerClient.PushDataLayerForDataLayerType('Event', applePayEventData, applePayEventOptions);
				}
			}

			applePaySession = new ApplePaySession(14, buffer['applePayRequest']);
			applePaySession.onvalidatemerchant = validateMerchant;
			applePaySession.onshippingcontactselected = shippingContactSelected;
			applePaySession.onshippingmethodselected = shippingMethodSelected;
			applePaySession.onpaymentmethodselected = paymentMethodSelected;
			applePaySession.oncouponcodechanged = couponCodeChanged;
			applePaySession.onpaymentauthorized = paymentAuthorized;
			applePaySession.oncancel = cancel;
			applePaySession.begin();
		}
	});
}

function validateMerchant(event) {
	fetch(Urls.ApplePay.ValidateMerchant, getFetchOptions('POST', event))
	.then(function(response) {
		return response.json();
	})
	.then(function(response) {
		applePaySession.completeMerchantValidation(response);
	})
	.catch(function(error) {
		console.error('ApplePay-ValidateMerchant', error);
	});
}

function shippingContactSelected(event) {
	fetch(Urls.ApplePay.ShippingContactSelected, getFetchOptions('POST', event))
	.then(function(response) {
		return response.json();
	})
	.then(function(response) {
		applePaySession.completeShippingContactSelection(response);
		if (!options || !options.ProductId) {
			$(document).trigger('Cart.Update');
		}
	})
	.catch(function(error) {
		console.error('ApplePay-ShippingContactSelected', error);
	});
}

function shippingMethodSelected(event) {
	fetch(Urls.ApplePay.ShippingMethodSelected, getFetchOptions('POST', event))
	.then(function(response) {
		return response.json();
	})
	.then(function(response) {
		applePaySession.completeShippingMethodSelection(response);
		if (!options || !options.ProductId) {
			$(document).trigger('Cart.Update');
		}
	})
	.catch(function(error) {
		console.error('ApplePay-ShippingMethodSelected', error);
	});
}

function paymentMethodSelected(event) {
	fetch(Urls.ApplePay.PaymentMethodSelected, getFetchOptions('POST', event))
	.then(function(response) {
		return response.json();
	})
	.then(function(response) {
		applePaySession.completePaymentMethodSelection(response);
	})
	.catch(function(error) {
		console.error('ApplePay-PaymentMethodSelected', error);
	});
}

function couponCodeChanged(event) {
	fetch(Urls.ApplePay.CouponCodeChanged)
	.then(function(response) { 
		return response.json();
	})
	.then(function(response) {
		applePaySession.completeCouponCodeChange(response);
	})
	.catch(function(error) {
		console.error('ApplePay-CouponCodeChanged', error);
	});
}

function paymentAuthorized(event) {
	fetch(Urls.ApplePay.PaymentAuthorized, getFetchOptions('POST', event))
	.then(function(response) { 
		return response.json();
	})
	.then(function(response) {
		if (response.status == 'success') {
			applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS);
		} else {
			applePaySession.completePayment(ApplePaySession.STATUS_FAILURE);
		}
	})
	.then(function(response) {
		if (event.payment) {
			if (event.payment.billingContact) {
				var billingAddressObject = {};
				billingAddressObject.FirstName = event.payment.billingContact.givenName;
				billingAddressObject.LastName = event.payment.billingContact.familyName;
				billingAddressObject.PrimaryLine = event.payment.billingContact.addressLines[0] || '';
				billingAddressObject.SecondaryLine = event.payment.billingContact.addressLines[1] || '';
				billingAddressObject.StateCode = event.payment.billingContact.administrativeArea;
				billingAddressObject.PostalCode = event.payment.billingContact.postalCode;
				billingAddressObject.City = event.payment.billingContact.locality;

				if (event.payment.shippingContact && event.payment.shippingContact.phone) {
					billingAddressObject.Phone = event.payment.shippingContact.phone.replace('+','');
				}

				if (options.isCheckoutPage) {
					$(document).trigger('SetAddressFromAddressVerification', $.extend(billingAddressObject, { AddressType: 'billing', DisableSubmitPayment: true, SkipUseBillingAsShipping: true }));
				}
			}

			if (event.payment.shippingContact) {
				var shippingAddressObject = {};
				shippingAddressObject.FirstName = event.payment.shippingContact.givenName;
				shippingAddressObject.LastName = event.payment.shippingContact.familyName;
				if (event.payment.shippingContact.addressLines) {
					shippingAddressObject.PrimaryLine = event.payment.shippingContact.addressLines[0] || '';
					shippingAddressObject.SecondaryLine = event.payment.shippingContact.addressLines[1] || '';
					shippingAddressObject.StateCode = event.payment.shippingContact.administrativeArea;
					shippingAddressObject.PostalCode = event.payment.shippingContact.postalCode;
					shippingAddressObject.City = event.payment.shippingContact.locality;
				}

				if (event.payment.shippingContact.phoneNumber) {
					shippingAddressObject.Phone = event.payment.shippingContact.phoneNumber.replace('+','');
				}

				if (event.payment.shippingContact.emailAddress) {
					shippingAddressObject.Email = event.payment.shippingContact.emailAddress;
				}

				if (options.isCheckoutPage) {
					$(document).trigger('SetAddressFromAddressVerification', $.extend(shippingAddressObject, { AddressType: 'shipping', DisableSubmitPayment: true }));
				}
			}
		}

		if (options.ProductId) {
			fetch(Urls.ApplePay.Confirmation, getFetchOptions('GET'))
			.then(function(response) {
				response.text().then(function(text) {
					dialog.open({
						html: text,
						options: {
							dialogClass: 'pt_order-confirmation',
							open: function() {
								$('body').addClass('dialog-open');
								OrderConfirmation.init();
								var dataLayerOptions = {
									PaymentMethod:  'Apple Pay'
								};
								$(document).off('click.OrderConfirmationModalClose').on('click.OrderConfirmationModalClose', '.ui-dialog.pt_order-confirmation .btn.continue', function(event) {
									event.preventDefault();
									dialog.close();
								});
								GoogleTagManagerClient.PushDataLayerForDataLayerType('ViewOrderConfirmation', null, dataLayerOptions).then(function() {
									$(document).trigger('ProductDetailPage.AddToCartOptionsSelect', { ProductId: $('#pid').val(), StoreId: $('.bopis-add-to-cart-options-container .selected-store').attr('store-id') });
								});
							},
							close: function(event, ui) {
								$('body').removeClass('dialog-open');
							}
						}
					});
				});
			})
			.catch(function(error) {
				console.error('ApplePay-Confirmation', error);
			});
		} else if (options.isCheckoutPage) {
			$(document).trigger('Cart.Update');
		} else {
			window.location = Urls.onePage;
		}

	})
	.catch(function(error) {
		console.error('ApplePay-PaymentAuthorized', error);
	});
}

function cancel(event) {
	fetch(Urls.ApplePay.Cancel, getFetchOptions('POST'))
	.then(function() {
		// applePaySession.abort();
		if (options.isCheckoutPage) {
			$(document).trigger('Cart.Update');
		}
	})
	.catch(function(error) {
		console.error('ApplePay-Cancel', error);
	});
}

// On PDP, the four events that call getApplePayPaymentRequest() don't all carry a usable
// ProductId in their payload - Cart.UpdateSuccess in particular is a generic cart-wide event,
// and the very first automatic firing on page load (before any variant is picked) has none
// either, since a master product has no orderable id yet. Without this, a pid-less call falls
// through getRequest()'s "no productId" branch, which nulls session.custom.ApplePayTemporaryBasketId
// outright - if that pid-less call resolves AFTER a legitimate product-specific one (no ordering
// guarantee between concurrent requests), it silently wipes the just-created temp basket
// reference, so every later step in the same Apple Pay sheet (shippingContactSelected,
// paymentMethodSelected) falls back to the real, empty basket and shows a $0.00 total. Always
// re-reading the current DOM state here avoids ever sending a pid-less request while a real
// product is being viewed - same fix already applied to GooglePay.js's getPdpPaymentRequestData().
function getPdpPaymentRequestData(data) {
	if (!options.ProductId) {
		return data;
	}
	return {
		ProductId: $('#pid').val(),
		StoreId: $('.bopis-add-to-cart-options-container .selected-store').attr('store-id')
	};
}

function getApplePayPaymentRequest(data) {
	// The button never shows without Apple Pay, and building a temp basket there collides with Google Pay's.
	if (!('ApplePaySession' in window && 'canMakePayments' in ApplePaySession && ApplePaySession.canMakePayments())) {
		return;
	}

	var urlSearchParameters;
	if (data && data.ProductId) {
		urlSearchParameters = new URLSearchParams();
		urlSearchParameters.append('pid', data.ProductId);
		if (data.StoreId) {
			urlSearchParameters.append('storeid', data.StoreId);
		}
		var bopisAddToCartOption = $('.bopis-add-to-cart-options-container').find('input[name="AddToCartOption"]:checked').val();
		if (bopisAddToCartOption) {
			urlSearchParameters.append('addtocartoption', bopisAddToCartOption);
		}
	}

	fetch(Urls.ApplePay.GetRequest + (urlSearchParameters ? '?' + urlSearchParameters : ''))
	.then(function(response) { 
		return response.json();
	})
	.then(function(applePayRequest) {
		buffer['applePayRequest'] = applePayRequest;
	})
	.catch(function(error) {
		console.error('ApplePay-GetRequest', error);
	});
}

function getFetchOptions(method, body) {
	var fetchOptions = {
		credentials: 'include'
	};
	if (method) {
		fetchOptions.method = method;
	}
	if (body) {
		fetchOptions.headers = {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
		}
		fetchOptions.body = JSON.stringify(filterEvent(body));
	}

	return fetchOptions;
}

function filterEvent(event) {
	var eventFiltered = {};
	for (var property in event) {
		if (!Event.prototype.hasOwnProperty(property)) {
			eventFiltered[property] = event[property];
		}
	}
	return eventFiltered;
}